import React from 'react';
import { useForm } from 'react-hook-form';
import { Modal, ModalBody, ModalHeader, Col, Row, ModalFooter, Form } from 'reactstrap';
import Button, { ButtonSizes, ButtonVariants } from '@/components/Button/Button';
import FormInput from '@/components/forms/FormInput';
import { TransactionStatus, TransactionType } from '@repo/common-types';
import { TransactionFilterDto } from '@/services/transactions/transactions-types';
interface TransactionsFilterProps {
  onClose: () => void;
  onApplyFilters: (filters: TransactionFilterDto) => void;
  currentFilters: TransactionFilterDto;
}

export const TransactionsFilter: React.FC<TransactionsFilterProps> = ({ onClose, onApplyFilters, currentFilters }) => {
  const { control, handleSubmit } = useForm({
    defaultValues: {
      ...currentFilters,
    },
  });

  const onSubmit = (data: TransactionFilterDto) => {
    const cleanedFilters = Object.entries(data).reduce(
      (acc, [key, value]) => {
        if (value !== undefined && value !== '') {
          acc[key] = value;
        }
        return acc;
      },
      {} as typeof currentFilters,
    );

    onApplyFilters(cleanedFilters);
    onClose();
  };

  const handleClear = () => {
    onApplyFilters({});
    onClose();
  };

  return (
    <Modal centered isOpen>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <ModalHeader toggle={onClose} className="d-flex justify-content-between align-items-center w-full">
          Filters
        </ModalHeader>
        <ModalBody>
          <Row className="g-3">
            <Col xs={12}>
              <FormInput
                label="User Alias"
                name="userAlias"
                control={control}
                type="text"
                placeholder="Search by user alias..."
              />
            </Col>
            <Col xs={12}>
              <FormInput label="Name" name="tableName" control={control} type="text" placeholder="Search by name..." />
            </Col>
            <Col xs={12}>
              <FormInput
                label="Transaction Type"
                name="type"
                control={control}
                type="select"
                options={[
                  { label: 'All Types', value: '' },
                  ...Object.values(TransactionType).map((type) => ({
                    label: type,
                    value: type,
                  })),
                ]}
              />
            </Col>
            <Col xs={12}>
              <FormInput
                label="Status"
                name="status"
                control={control}
                type="select"
                options={[
                  { label: 'All Statuses', value: '' },
                  ...Object.values(TransactionStatus).map((status) => ({
                    label: status,
                    value: status,
                  })),
                ]}
              />
            </Col>
            <Col xs={12}>
              <FormInput
                label="Transaction ID"
                name="txId"
                control={control}
                type="text"
                placeholder="Search by transaction ID..."
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className="btn btn-outline"
            variant={ButtonVariants.secondary}
            size={ButtonSizes.sm}
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            className="btn btn-primary"
            variant={ButtonVariants.primary}
            size={ButtonSizes.sm}
            onClick={handleSubmit(onSubmit)}
          >
            Apply Filter
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default TransactionsFilter;
